import { DateTime, Duration } from "luxon";
export function DateTime_toTransferable(dt) {
    return dt ? dt.toISO() : "";
}
export function DateTime_fromTransferable(o) {
    return DateTime.fromISO(o);
}
export function Duration_toTransferable(d) {
    return d.toObject();
}
export function Duration_fromTransferable(o) {
    return Duration.fromObject(o);
}
//# sourceMappingURL=DateTime.js.map